module.exports = __webpack_public_path__ + "static/media/bank7.77abbc6b.png";